export const SEARCH_CATEGORIES = {
  PLAYLISTS: 'PLAYLISTS',

  CAREER_OPPORTUNITIES_INTERNSHIPS: 'INTERNSHIPS',
  CAREER_OPPORTUNITIES_JOBS: 'JOBS',
  CAREER_OPPORTUNITIES_CAREER_PATH: 'CAREER_PATH',
  CAREER_OPPORTUNITIES_EMPLOYERS: 'EMPLOYERS',

  SCHOLARSHIPS_SCHOLARSHIPS: 'SCHOLARSHIPS',

  SCHOLARSHIPS_FINANCIAL_AID_COMPETENCY: 'FINANCIAL_AID_COMPETENCY',

  // institutions - come back to this

  RESOURCES_NUGGET_VIDEO: 'NUGGET_VIDEO',
  RESOURCES_NUGGET_BOOK: 'NUGGET_BOOK',
  RESOURCES_NUGGET_ARTICLE: 'NUGGET_ARTICLE',
  RESOURCES_COMPETENCY: 'COMPETENCY',

  TOOLS: 'TOOLS',

  MAJORS: 'MAJORS',
  INDUSTRIES: 'INDUSTRIES',

  PEOPLE: 'PEOPLE',
  PEOPLE_INTERNAL: 'PEOPLE_INTERNAL',
  PEOPLE_EXTERNAL: 'PEOPLE_EXTERNAL',

  NUGGET_STORIES: 'NUGGET_STORIES',
  NUGGET_GROW_BY_DOING: 'NUGGET_GROW_BY_DOING',
} as const;

export const SEARCH_CATEGORIES_SCHOLARSHIPS = {
  TYPE_ALL: 'SCHOLARSHIP_TYPE_ALL',
  TYPE_SCHOLARSHIPS: 'SCHOLARSHIP_TYPE_SCHOLARSHIP',
  TYPE_FORGIVABLE_LOAN: 'SCHOLARSHIP_TYPE_FORGIVABLE_LOAN',
  TYPE_GRANT: 'SCHOLARSHIP_TYPE_GRANT',
  TYPE_CORPORATE: 'SCHOLARSHIP_TYPE_CORPORATE',
  TYPE_FELLOWSHIP: 'SCHOLARSHIP_TYPE_FELLOWSHIP',

  PRE_FILTERED: 'SCHOLARSHIP_AWARD_PRE_FILTERED',
} as const;

export const SEARCH_CATEGORIES_INTERNSHIPS = {
  MSA_ALL: 'INTERNSHIP_MSA_ALL',
  MSA_AKRON: 'INTERNSHIP_MSA_AKRON',
  MSA_ALBANY: 'INTERNSHIP_MSA_ALBANY',
  MSA_ALBUQUERQUE: 'INTERNSHIP_MSA_ALBUQUERQUE',
  MSA_ALLENTOWN: 'INTERNSHIP_MSA_ALLENTOWN',
  MSA_ANN_ARBOR: 'INTERNSHIP_MSA_ANN_ARBOR',
  MSA_ATLANTA: 'INTERNSHIP_MSA_ATLANTA',
  MSA_AUSTIN: 'INTERNSHIP_MSA_AUSTIN',
  MSA_BAKERSFIELD: 'INTERNSHIP_MSA_BAKERSFIELD',
  MSA_BALTIMORE: 'INTERNSHIP_MSA_BALTIMORE',
  MSA_BATON_ROUGE: 'INTERNSHIP_MSA_BATON_ROUGE',
  MSA_BELLEVUE: 'INTERNSHIP_MSA_BELLEVUE',
  MSA_BELLINGHAM: 'INTERNSHIP_MSA_BELLINGHAM',
  MSA_BIRMINGHAM: 'INTERNSHIP_MSA_BIRMINGHAM',
  MSA_BOISE: 'INTERNSHIP_MSA_BOISE',
  MSA_BOSTON: 'INTERNSHIP_MSA_BOSTON',
  MSA_BOULDER: 'INTERNSHIP_MSA_BOULDER',
  MSA_BREMERTON: 'INTERNSHIP_MSA_BREMERTON',
  MSA_BRIDGEPORT: 'INTERNSHIP_MSA_BRIDGEPORT',
  MSA_BUFFALO: 'INTERNSHIP_MSA_BUFFALO',
  MSA_CAMDEN: 'INTERNSHIP_MSA_CAMDEN',
  MSA_CHARLOTTE: 'INTERNSHIP_MSA_CHARLOTTE',
  MSA_CHATTANOOGA: 'INTERNSHIP_MSA_CHATTANOOGA',
  MSA_CHICAGO: 'INTERNSHIP_MSA_CHICAGO',
  MSA_CINCINNATI: 'INTERNSHIP_MSA_CINCINNATI',
  MSA_CLEVELAND: 'INTERNSHIP_MSA_CLEVELAND',
  MSA_COLORADO_SPRINGS: 'INTERNSHIP_MSA_COLORADO_SPRINGS',
  MSA_COLUMBUS: 'INTERNSHIP_MSA_COLUMBUS',
  MSA_DALLAS: 'INTERNSHIP_MSA_DALLAS',
  MSA_DAYTON: 'INTERNSHIP_MSA_DAYTON',
  MSA_DENVER: 'INTERNSHIP_MSA_DENVER',
  MSA_DES_MOINES: 'INTERNSHIP_MSA_DES_MOINES',
  MSA_DETROIT: 'INTERNSHIP_MSA_DETROIT',
  MSA_DURHAM: 'INTERNSHIP_MSA_DURHAM',
  MSA_EL_PASO: 'INTERNSHIP_MSA_EL_PASO',
  MSA_EUGENE: 'INTERNSHIP_MSA_EUGENE',
  MSA_EVERETT: 'INTERNSHIP_MSA_EVERETT',
  MSA_FORT_COLLINS: 'INTERNSHIP_MSA_FORT_COLLINS',
  MSA_FRESNO: 'INTERNSHIP_MSA_FRESNO',
  MSA_GRAND_RAPIDS: 'INTERNSHIP_MSA_GRAND_RAPIDS',
  MSA_GREENSBORO: 'INTERNSHIP_MSA_GREENSBORO',
  MSA_GREENVILLE: 'INTERNSHIP_MSA_GREENVILLE',
  MSA_HARRISBURG: 'INTERNSHIP_MSA_HARRISBURG',
  MSA_HARTFORD: 'INTERNSHIP_MSA_HARTFORD',
  MSA_HOUSTON: 'INTERNSHIP_MSA_HOUSTON',
  MSA_HUNTSVILLE: 'INTERNSHIP_MSA_HUNTSVILLE',
  MSA_INDIANAPOLIS: 'INTERNSHIP_MSA_INDIANAPOLIS',
  MSA_IRVING: 'INTERNSHIP_MSA_IRVING',
  MSA_JACKSONVILLE: 'INTERNSHIP_MSA_JACKSONVILLE',
  MSA_KANSAS_CITY: 'INTERNSHIP_MSA_KANSAS_CITY',
  MSA_KENNEWICK: 'INTERNSHIP_MSA_KENNEWICK',
  MSA_KIRKLAND: 'INTERNSHIP_MSA_KIRKLAND',
  MSA_KNOXVILLE: 'INTERNSHIP_MSA_KNOXVILLE',
  MSA_LANSING: 'INTERNSHIP_MSA_LANSING',
  MSA_LAS_VEGAS: 'INTERNSHIP_MSA_LAS_VEGAS',
  MSA_LEXINGTON: 'INTERNSHIP_MSA_LEXINGTON',
  MSA_LITTLE_ROCK: 'INTERNSHIP_MSA_LITTLE_ROCK',
  MSA_LOS_ANGELES: 'INTERNSHIP_MSA_LOS_ANGELES',
  MSA_LOUISVILLE: 'INTERNSHIP_MSA_LOUISVILLE',
  MSA_LUBBOCK: 'INTERNSHIP_MSA_LUBBOCK',
  MSA_MADISON: 'INTERNSHIP_MSA_MADISON',
  MSA_MEMPHIS: 'INTERNSHIP_MSA_MEMPHIS',
  MSA_MESA: 'INTERNSHIP_MSA_MESA',
  MSA_MIAMI: 'INTERNSHIP_MSA_MIAMI',
  MSA_MILWAUKEE: 'INTERNSHIP_MSA_MILWAUKEE',
  MSA_MINNEAPOLIS: 'INTERNSHIP_MSA_MINNEAPOLIS',
  MSA_MODESTO: 'INTERNSHIP_MSA_MODESTO',
  MSA_NASHVILLE: 'INTERNSHIP_MSA_NASHVILLE',
  MSA_NEWARK: 'INTERNSHIP_MSA_NEWARK',
  MSA_NEW_HAVEN: 'INTERNSHIP_MSA_NEW_HAVEN',
  MSA_NEW_ORLEANS: 'INTERNSHIP_MSA_NEW_ORLEANS',
  MSA_NEW_YORK: 'INTERNSHIP_MSA_NEW_YORK',
  MSA_OKLAHOMA_CITY: 'INTERNSHIP_MSA_OKLAHOMA_CITY',
  MSA_OLYMPIA: 'INTERNSHIP_MSA_OLYMPIA',
  MSA_OMAHA: 'INTERNSHIP_MSA_OMAHA',
  MSA_ORLANDO: 'INTERNSHIP_MSA_ORLANDO',
  MSA_PHILADELPHIA: 'INTERNSHIP_MSA_PHILADELPHIA',
  MSA_PHOENIX: 'INTERNSHIP_MSA_PHOENIX',
  MSA_PITTSBURGH: 'INTERNSHIP_MSA_PITTSBURGH',
  MSA_PLANO: 'INTERNSHIP_MSA_PLANO',
  MSA_PORTLAND: 'INTERNSHIP_MSA_PORTLAND',
  MSA_PROVIDENCE: 'INTERNSHIP_MSA_PROVIDENCE',
  MSA_PROVO: 'INTERNSHIP_MSA_PROVO',
  MSA_RALEIGH: 'INTERNSHIP_MSA_RALEIGH',
  MSA_REDMOND: 'INTERNSHIP_MSA_REDMOND',
  MSA_RENO: 'INTERNSHIP_MSA_RENO',
  MSA_RENTON: 'INTERNSHIP_MSA_RENTON',
  MSA_RICHMOND: 'INTERNSHIP_MSA_RICHMOND',
  MSA_RIVERSIDE: 'INTERNSHIP_MSA_RIVERSIDE',
  MSA_ROCHESTER: 'INTERNSHIP_MSA_ROCHESTER',
  MSA_SACRAMENTO: 'INTERNSHIP_MSA_SACRAMENTO',
  MSA_SALT_LAKE_CITY: 'INTERNSHIP_MSA_SALT_LAKE_CITY',
  MSA_SAN_ANTONIO: 'INTERNSHIP_MSA_SAN_ANTONIO',
  MSA_SAN_DIEGO: 'INTERNSHIP_MSA_SAN_DIEGO',
  MSA_SAN_FRANCISCO: 'INTERNSHIP_MSA_SAN_FRANCISCO',
  MSA_SAN_JOSE: 'INTERNSHIP_MSA_SAN_JOSE',
  MSA_SAVANNAH: 'INTERNSHIP_MSA_SAVANNAH',
  MSA_SCOTTSDALE: 'INTERNSHIP_MSA_SCOTTSDALE',
  MSA_SEATTLE: 'INTERNSHIP_MSA_SEATTLE',
  MSA_SPOKANE: 'INTERNSHIP_MSA_SPOKANE',
  MSA_STOCKTON: 'INTERNSHIP_MSA_STOCKTON',
  MSA_ST_LOUIS: 'INTERNSHIP_MSA_ST_LOUIS',
  MSA_SYRACUSE: 'INTERNSHIP_MSA_SYRACUSE',
  MSA_TACOMA: 'INTERNSHIP_MSA_TACOMA',
  MSA_TAMPA: 'INTERNSHIP_MSA_TAMPA',
  MSA_TEMPE: 'INTERNSHIP_MSA_TEMPE',
  MSA_TOLEDO: 'INTERNSHIP_MSA_TOLEDO',
  MSA_TUCSON: 'INTERNSHIP_MSA_TUCSON',
  MSA_TULSA: 'INTERNSHIP_MSA_TULSA',
  MSA_VANCOUVER: 'INTERNSHIP_MSA_VANCOUVER',
  MSA_VIRGINIA_BEACH: 'INTERNSHIP_MSA_VIRGINIA_BEACH',
  MSA_WASHINGTON: 'INTERNSHIP_MSA_WASHINGTON',
  MSA_WICHITA: 'INTERNSHIP_MSA_WICHITA',
  MSA_WORCESTER: 'INTERNSHIP_MSA_WORCESTER',
  MSA_YAKIMA: 'INTERNSHIP_MSA_YAKIMA',

  // Identify the state groups in the Geography dropdown. Selecting a state selects
  // the MSA_ keys inside it -- these are never sent as filters themselves.
  MSA_STATE_AL: 'INTERNSHIP_MSA_STATE_AL',
  MSA_STATE_AR: 'INTERNSHIP_MSA_STATE_AR',
  MSA_STATE_AZ: 'INTERNSHIP_MSA_STATE_AZ',
  MSA_STATE_CA: 'INTERNSHIP_MSA_STATE_CA',
  MSA_STATE_CO: 'INTERNSHIP_MSA_STATE_CO',
  MSA_STATE_CT: 'INTERNSHIP_MSA_STATE_CT',
  MSA_STATE_DC: 'INTERNSHIP_MSA_STATE_DC',
  MSA_STATE_FL: 'INTERNSHIP_MSA_STATE_FL',
  MSA_STATE_GA: 'INTERNSHIP_MSA_STATE_GA',
  MSA_STATE_IA: 'INTERNSHIP_MSA_STATE_IA',
  MSA_STATE_ID: 'INTERNSHIP_MSA_STATE_ID',
  MSA_STATE_IL: 'INTERNSHIP_MSA_STATE_IL',
  MSA_STATE_IN: 'INTERNSHIP_MSA_STATE_IN',
  MSA_STATE_KS: 'INTERNSHIP_MSA_STATE_KS',
  MSA_STATE_KY: 'INTERNSHIP_MSA_STATE_KY',
  MSA_STATE_LA: 'INTERNSHIP_MSA_STATE_LA',
  MSA_STATE_MA: 'INTERNSHIP_MSA_STATE_MA',
  MSA_STATE_MD: 'INTERNSHIP_MSA_STATE_MD',
  MSA_STATE_MI: 'INTERNSHIP_MSA_STATE_MI',
  MSA_STATE_MN: 'INTERNSHIP_MSA_STATE_MN',
  MSA_STATE_MO: 'INTERNSHIP_MSA_STATE_MO',
  MSA_STATE_NC: 'INTERNSHIP_MSA_STATE_NC',
  MSA_STATE_NE: 'INTERNSHIP_MSA_STATE_NE',
  MSA_STATE_NJ: 'INTERNSHIP_MSA_STATE_NJ',
  MSA_STATE_NM: 'INTERNSHIP_MSA_STATE_NM',
  MSA_STATE_NV: 'INTERNSHIP_MSA_STATE_NV',
  MSA_STATE_NY: 'INTERNSHIP_MSA_STATE_NY',
  MSA_STATE_OH: 'INTERNSHIP_MSA_STATE_OH',
  MSA_STATE_OK: 'INTERNSHIP_MSA_STATE_OK',
  MSA_STATE_OR: 'INTERNSHIP_MSA_STATE_OR',
  MSA_STATE_PA: 'INTERNSHIP_MSA_STATE_PA',
  MSA_STATE_RI: 'INTERNSHIP_MSA_STATE_RI',
  MSA_STATE_SC: 'INTERNSHIP_MSA_STATE_SC',
  MSA_STATE_TN: 'INTERNSHIP_MSA_STATE_TN',
  MSA_STATE_TX: 'INTERNSHIP_MSA_STATE_TX',
  MSA_STATE_UT: 'INTERNSHIP_MSA_STATE_UT',
  MSA_STATE_VA: 'INTERNSHIP_MSA_STATE_VA',
  MSA_STATE_WA: 'INTERNSHIP_MSA_STATE_WA',
  MSA_STATE_WI: 'INTERNSHIP_MSA_STATE_WI',

  MSA_REMOTE: 'INTERNSHIP_MSA_REMOTE',

  CAREER_PATH_ALL: 'INTERNSHIP_CAREER_PATH_ALL',

  INDUSTRY_ALL: 'INTERNSHIP_INDUSTRY_ALL',

  JOB_TYPE_ALL: 'INTERNSHIP_JOB_TYPE_ALL',
  JOB_TYPE_FULL_TIME: 'INTERNSHIP_JOB_TYPE_FULL_TIME',
  JOB_TYPE_INTERNSHIP: 'INTERNSHIP_JOB_TYPE_INTERNSHIP',
} as const;

export const SEARCH_CATEGORIES_COLLEGES = {
  COLLEGE_ALL: 'COLLEGE_ALL',

  COLLEGE_TYPE_ALL: 'COLLEGE_TYPE_ALL',
  COLLEGE_TYPE_FOUR_YEAR: 'COLLEGE_TYPE_FOUR_YEAR',
  COLLEGE_TYPE_TWO_YEAR: 'COLLEGE_TYPE_TWO_YEAR',
  COLLEGE_TYPE_CERTIFICATE: 'COLLEGE_TYPE_CERTIFICATE',

  COLLEGE_CONTROL_ALL: 'COLLEGE_CONTROL_ALL',
  COLLEGE_CONTROL_PUBLIC: 'COLLEGE_CONTROL_PUBLIC',
  COLLEGE_CONTROL_PRIVATE: 'COLLEGE_CONTROL_PRIVATE',

  COLLEGE_FOCUS_ALL: 'COLLEGE_FOCUS_ALL',
  COLLEGE_FOCUS_RESEARCH: 'COLLEGE_FOCUS_RESEARCH',
  COLLEGE_FOCUS_LIBERAL_ARTS: 'COLLEGE_FOCUS_LIBERAL_ARTS',

  COLLEGE_SELECTIVITY_ALL: 'COLLEGE_SELECTIVITY_ALL',
  COLLEGE_SELECTIVITY_HIGHLY_SELECTIVE: 'COLLEGE_SELECTIVITY_HIGHLY_SELECTIVE',
  COLLEGE_SELECTIVITY_SOMEWHAT_SELECTIVE: 'COLLEGE_SELECTIVITY_SOMEWHAT_SELECTIVE',
  COLLEGE_SELECTIVITY_LESS_SELECTIVE: 'COLLEGE_SELECTIVITY_LESS_SELECTIVE',

  COLLEGE_SIZE_ALL: 'COLLEGE_SIZE_ALL',
  COLLEGE_SIZE_VERY_SMALL: 'COLLEGE_SIZE_VERY_SMALL',
  COLLEGE_SIZE_SMALL: 'COLLEGE_SIZE_SMALL',
  COLLEGE_SIZE_MEDIUM: 'COLLEGE_SIZE_MEDIUM',
  COLLEGE_SIZE_LARGE: 'COLLEGE_SIZE_LARGE',

  COLLEGE_REGION_ALL: 'COLLEGE_REGION_ALL',

  COLLEGE_STATE_ALL: 'COLLEGE_STATE_ALL',
  COLLEGE_STATE_ALABAMA: 'COLLEGE_STATE_ABBREVIATION_AL',
  COLLEGE_STATE_ALASKA: 'COLLEGE_STATE_ABBREVIATION_AK',
  COLLEGE_STATE_ARIZONA: 'COLLEGE_STATE_ABBREVIATION_AZ',
  COLLEGE_STATE_ARKANSAS: 'COLLEGE_STATE_ABBREVIATION_AR',
  COLLEGE_STATE_CALIFORNIA: 'COLLEGE_STATE_ABBREVIATION_CA',
  COLLEGE_STATE_COLORADO: 'COLLEGE_STATE_ABBREVIATION_CO',
  COLLEGE_STATE_CONNECTICUT: 'COLLEGE_STATE_ABBREVIATION_CT',
  COLLEGE_STATE_DELAWARE: 'COLLEGE_STATE_ABBREVIATION_DE',
  COLLEGE_STATE_FLORIDA: 'COLLEGE_STATE_ABBREVIATION_FL',
  COLLEGE_STATE_GEORGIA: 'COLLEGE_STATE_ABBREVIATION_GA',
  COLLEGE_STATE_HAWAII: 'COLLEGE_STATE_ABBREVIATION_HI',
  COLLEGE_STATE_IDAHO: 'COLLEGE_STATE_ABBREVIATION_ID',
  COLLEGE_STATE_ILLINOIS: 'COLLEGE_STATE_ABBREVIATION_IL',
  COLLEGE_STATE_INDIANA: 'COLLEGE_STATE_ABBREVIATION_IN',
  COLLEGE_STATE_IOWA: 'COLLEGE_STATE_ABBREVIATION_IA',
  COLLEGE_STATE_KANSAS: 'COLLEGE_STATE_ABBREVIATION_KS',
  COLLEGE_STATE_KENTUCKY: 'COLLEGE_STATE_ABBREVIATION_KY',
  COLLEGE_STATE_LOUISIANA: 'COLLEGE_STATE_ABBREVIATION_LA',
  COLLEGE_STATE_MAINE: 'COLLEGE_STATE_ABBREVIATION_ME',
  COLLEGE_STATE_MARYLAND: 'COLLEGE_STATE_ABBREVIATION_MD',
  COLLEGE_STATE_MASSACHUSETTS: 'COLLEGE_STATE_ABBREVIATION_MA',
  COLLEGE_STATE_MICHIGAN: 'COLLEGE_STATE_ABBREVIATION_MI',
  COLLEGE_STATE_MINNESOTA: 'COLLEGE_STATE_ABBREVIATION_MN',
  COLLEGE_STATE_MISSISSIPPI: 'COLLEGE_STATE_ABBREVIATION_MS',
  COLLEGE_STATE_MISSOURI: 'COLLEGE_STATE_ABBREVIATION_MO',
  COLLEGE_STATE_MONTANA: 'COLLEGE_STATE_ABBREVIATION_MT',
  COLLEGE_STATE_NEBRASKA: 'COLLEGE_STATE_ABBREVIATION_NE',
  COLLEGE_STATE_NEVADA: 'COLLEGE_STATE_ABBREVIATION_NV',
  COLLEGE_STATE_NEW_HAMPSHIRE: 'COLLEGE_STATE_ABBREVIATION_NH',
  COLLEGE_STATE_NEW_JERSEY: 'COLLEGE_STATE_ABBREVIATION_NJ',
  COLLEGE_STATE_NEW_MEXICO: 'COLLEGE_STATE_ABBREVIATION_NM',
  COLLEGE_STATE_NEW_YORK: 'COLLEGE_STATE_ABBREVIATION_NY',
  COLLEGE_STATE_NORTH_CAROLINA: 'COLLEGE_STATE_ABBREVIATION_NC',
  COLLEGE_STATE_NORTH_DAKOTA: 'COLLEGE_STATE_ABBREVIATION_ND',
  COLLEGE_STATE_OHIO: 'COLLEGE_STATE_ABBREVIATION_OH',
  COLLEGE_STATE_OKLAHOMA: 'COLLEGE_STATE_ABBREVIATION_OK',
  COLLEGE_STATE_OREGON: 'COLLEGE_STATE_ABBREVIATION_OR',
  COLLEGE_STATE_PENNSYLVANIA: 'COLLEGE_STATE_ABBREVIATION_PA',
  COLLEGE_STATE_RHODE_ISLAND: 'COLLEGE_STATE_ABBREVIATION_RI',
  COLLEGE_STATE_SOUTH_CAROLINA: 'COLLEGE_STATE_ABBREVIATION_SC',
  COLLEGE_STATE_SOUTH_DAKOTA: 'COLLEGE_STATE_ABBREVIATION_SD',
  COLLEGE_STATE_TENNESSEE: 'COLLEGE_STATE_ABBREVIATION_TN',
  COLLEGE_STATE_TEXAS: 'COLLEGE_STATE_ABBREVIATION_TX',
  COLLEGE_STATE_UTAH: 'COLLEGE_STATE_ABBREVIATION_UT',
  COLLEGE_STATE_VERMONT: 'COLLEGE_STATE_ABBREVIATION_VT',
  COLLEGE_STATE_VIRGINIA: 'COLLEGE_STATE_ABBREVIATION_VA',
  COLLEGE_STATE_WASHINGTON: 'COLLEGE_STATE_ABBREVIATION_WA',
  COLLEGE_STATE_WEST_VIRGINIA: 'COLLEGE_STATE_ABBREVIATION_WV',
  COLLEGE_STATE_WISCONSIN: 'COLLEGE_STATE_ABBREVIATION_WI',
  COLLEGE_STATE_WYOMING: 'COLLEGE_STATE_ABBREVIATION_WY',
} as const;

export const SEARCH_CATEGORIES_EMPLOYERS = {
  EMPLOYER_ALL: 'EMPLOYER_ALL',

  EMPLOYER_SIZE_ALL: 'EMPLOYER_SIZE_ALL',
  EMPLOYER_SIZE_SMALL: 'EMPLOYER_SIZE_SMALL',
  EMPLOYER_SIZE_MEDIUM: 'EMPLOYER_SIZE_MEDIUM',
  EMPLOYER_SIZE_LARGE: 'EMPLOYER_SIZE_LARGE',

  EMPLOYER_INDUSTRY_ALL: 'EMPLOYER_INDUSTRY_ALL',

  EMPLOYER_TRACK_ALL: 'EMPLOYER_TRACK_ALL',
  EMPLOYER_TRACK_SEMI_SKILLED: 'EMPLOYER_TRACK_SEMI_SKILLED',
  EMPLOYER_TRACK_TRADES: 'EMPLOYER_TRACK_TRADES',
  EMPLOYER_TRACK_MIDDLE_TIER: 'EMPLOYER_TRACK_MIDDLE_TIER',
  EMPLOYER_TRACK_UPPER_TIER: 'EMPLOYER_TRACK_UPPER_TIER',
  EMPLOYER_TRACK_TOP_TIER: 'EMPLOYER_TRACK_TOP_TIER',
} as const;

export const ALL_SEARCH_CATEGORIES = {
  ...SEARCH_CATEGORIES,
  ...SEARCH_CATEGORIES_SCHOLARSHIPS,
  ...SEARCH_CATEGORIES_INTERNSHIPS,
  ...SEARCH_CATEGORIES_COLLEGES,
  ...SEARCH_CATEGORIES_EMPLOYERS,
};
